import { createFileRoute } from '@tanstack/react-router';
import { Schema } from 'effect';
import { DriftPage } from '../../../regulatory-drift/drift-page.tsx';
import {
  EcosystemSearch,
  ecosystemSearchOf,
  requestedEcosystemOf,
} from '../../search/ecosystem-search.ts';
import { InvalidLinkPage } from '../../search/invalid-link-page.tsx';

// Declared inline: the route plugin splits `component` and `errorComponent` into lazy bindings it
// declares after the options. The URL tests mount `Route.options` in a memory router.
export const Route = createFileRoute('/drift-regulatorio/')({
  validateSearch: Schema.toStandardSchemaV1(EcosystemSearch),
  component: DriftRoute,
  errorComponent: InvalidLinkPage,
});

// Another ecosystem is another view: it gets its own history entry.
function DriftRoute(): JSX.Element {
  const navigate = Route.useNavigate();
  return (
    <DriftPage
      ecosystem={requestedEcosystemOf(Route.useSearch())}
      onEcosystem={(next) => {
        void navigate({ search: ecosystemSearchOf(next) });
      }}
    />
  );
}
